<script lang="ts" setup>
import { useI18nPlugin } from '@/plugins/app-internationalization/i18n'

const { updateLocale, locale } = useI18nPlugin()

const languages = computed<{ value: 'fr' | 'en'; label: string }[]>(() => [
    { value: 'fr', label: $t('ca.default.french') },
    { value: 'en', label: $t('ca.default.english') },
])

const label = computed(() => `${$t('ca.default.language')} (${locale.value})`)
</script>
<template>
    <VMenu open-on-hover>
        <template #activator="{ props }">
            <VBtn v-bind="props" :text="label" :rounded="false" />
        </template>
        <VList>
            <VListItem
                v-for="(item, index) in languages"
                :key="index"
                @click="updateLocale(item.value)"
            >
                <VListItemTitle>{{ item.label }}</VListItemTitle>
            </VListItem>
        </VList>
    </VMenu>
</template>
